export default "__VITE_ASSET__DI__tFuX__"